// Dedicated Grooming page. Assembles three per-dog experiences:
//   • Bath rhythm card (next-bath countdown + one-tap reminder)
//   • Grooming sessions + product library (with before/after photos)
//   • Coat-condition log for between-groom check-ins
import { useDogs } from "@/context/DogsContext";
import GroomingSection from "@/components/app/GroomingSection";
import GroomingPhotoDiary from "@/components/app/GroomingPhotoDiary";
import GroomersCard from "@/components/app/GroomersCard";
import BathCadenceCard from "@/components/app/BathCadenceCard";
import CoatConditionSection from "@/components/app/CoatConditionSection";
import EmptyDogState from "@/components/app/EmptyDogState";
import { SectionTitle } from "@/components/app/Bits";

export default function GroomingPage() {
  const { activeDog } = useDogs();
  if (!activeDog) return <EmptyDogState />;
  return (
    <div className="space-y-8" data-testid="grooming-page">
      <SectionTitle overline="Coat & care" title="Grooming" />
      <p className="text-sm text-muted-foreground max-w-2xl -mt-4">
        Track sessions and the products you actually reach for with{" "}
        <strong>{activeDog.name}</strong>. What worked, what didn&apos;t, and when the next bath is due.
      </p>

      <BathCadenceCard dog={activeDog} />
      <GroomersCard dogId={activeDog.id} />
      <GroomingPhotoDiary dog={activeDog} />
      <GroomingSection dog={activeDog} />
      <CoatConditionSection dog={activeDog} />
    </div>
  );
}
